module.exports = __webpack_public_path__ + "static/media/cliente-bayer.5a79e9de.webp";